import React from "react";
import { useT } from "../i18n";

const MAP_EMBED_URL =
  "https://www.google.com/maps/d/embed?mid=1NmbVmD2iCmelFO_s3IEryrYJypkNMz4&ehbc=2E312F";

export default function MapView() {
  const t = useT();
  return (
    <div className="p-2 sm:p-4">
      <h1 className="text-lg font-semibold text-gray-800 mb-2">{t("nav.map")}</h1>
      <div className="w-full" style={{ height: "calc(100vh - 8rem)" }}>
        <iframe
          src={MAP_EMBED_URL}
          title={t("nav.map")}
          className="w-full h-full border-0 rounded-md shadow-sm"
          allowFullScreen
        />
      </div>
    </div>
  );
}
